import {
  ExaminationDetails,
  TaskInformation,
  QSetReviewSubtaskPageHeader,
  useQSetReviewSubtask,
} from '@exam-management/qset-review-subtask-details';
import { Flex } from '@shared/components';

export default function QSetReviewSubtaskDetailsPage() {
  const { roles } = useQSetReviewSubtask();

  return (
    <>
      <QSetReviewSubtaskPageHeader />
      <Flex
        sx={(theme) => ({ p: theme.spacing(6), flexDirection: 'column', gap: theme.spacing(6) })}
      >
        {roles.isAssignee ? null : <TaskInformation />}
        <ExaminationDetails />
      </Flex>
    </>
  );
}
